module.exports = __webpack_public_path__ + "files/172b24031bec3b90722e79ad46813082.png";